import {FBFieldBaseOptions} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {EventBase} from "shared/core/Events/EventManager";

export class GetModel extends EventBase {
    ReturnType: FBFieldBaseModel;

    constructor(public parent:FBColumnModel,public Options:FBFieldBaseOptions,public PreviousData:any=null) {
        super();
    }

    public static GetName() {
        return 'GetModel';
    }
}